import {combineReducers} from 'redux';
import {getSuccessActionType} from '../utils';
import {getErrorReducer, getStatusReducer} from './utils/generators';
import {CREATE_STUDENT, FETCH_STUDENT_DATA, UPDATE_STUDENT_TYPE} from '../constants/student';
import {CHECK_SMS_KEY, UPDATE_USER_DATA} from '../constants/user';

const initialData = {};

function data(state = initialData, action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_STUDENT_DATA):
      return action.payload;

    case getSuccessActionType(CREATE_STUDENT):
    case getSuccessActionType(UPDATE_STUDENT_TYPE):
      return action.payload;

    case getSuccessActionType(UPDATE_USER_DATA):
      return {...state, user: action.payload};

    case getSuccessActionType(CHECK_SMS_KEY):
      return {...state, user: {...state.user, mobileVerified: true}};

    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_STUDENT_DATA]),
  error: getErrorReducer([FETCH_STUDENT_DATA]),
  data
});
